if (!customElements.get('expanding-drawer')) {
  customElements.define(
    'expanding-drawer',
    class Drawer extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
      }
      
      connectedCallback() {
        this.trigger = this.querySelector(".drawer-trigger");
        this.target = this.querySelector(".drawer-target");
        if (this.trigger && this.target) {
          this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        } else {
          console.warn('Expanding drawer requires .drawer-trigger and .drawer-target elements.');
        }
      }

      disconnectedCallback() { this.trigger.removeEventListener('click', this.onTriggerClick); }

      onTriggerClick(event) {
        event.preventDefault();
        this.isOpen = !this.isOpen;
        this.trigger.setAttribute('aria-expanded', this.isOpen);
        if (this.isOpen) {
          this.target.classList.remove("grid-rows-[0fr]");
          this.target.classList.add("grid-rows-[1fr]");
          this.target.classList.add("drawer-is-open");
          this.trigger.classList.add("drawer-is-open");
        } else {
          this.target.classList.remove("grid-rows-[1fr]");
          this.target.classList.add("grid-rows-[0fr]");
          this.target.classList.remove("drawer-is-open");
          this.trigger.classList.remove("drawer-is-open");
        }
      }
    }
  );
}